import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Row, Col, Button } from "reactstrap";
import Title from "./../../components/general/AdminPageTitle/AdminPageTitle";
import ActionButtons from "./../../components/page/production/ActionButtons/ActionButtons"
import classes from './productionPage.module.scss'

class ProductionPage extends Component {

  render() {

    return (
      <Fragment>
        <Helmet>
          <title>Boxi Admin | Production</title>
        </Helmet>
        <Col>
          <Title>Production</Title>
          <div className={classes.msg}>
            Select which section you want to access from side bar dropdown of Production
          </div>
        </Col>
      </Fragment>
    );
    }
}

export default withRouter(ProductionPage);
